import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';
import Modal from '../Modal';
import Button from '../Button';
import { isMobile } from '../Helpers';
import Header from '../Heading/head';

export const TimeoutWarningModal = ({ isOpen, isLoggedIn, sessionTimedOut, onLogoff, sessionKeepAlive, timeLeft }) => (
  <div>
    <Modal
      opened={isOpen}
      closeButton={<></>}
      disableOutsideClick
      modalBody={
        <div className="modalOverlay" style={{ position: 'relative', zIndex: '1' }}>
          {' '}
          {sessionTimedOut === false && (
            <div className="margin0 noPad" id="sessionWarning">
              <Row>
                <Col xs={10} sm={12} lg={12}>
                  {isMobile() && (
                    <Header size="titleMedium" className="pad24 onlyBottomPad">
                      {isLoggedIn
                        ? 'It looks like your session is about to expire.'
                        : `Just a heads up that your current session will expire in ${timeLeft} minutes because of inactivity.`}
                    </Header>
                  )}
                  {!isMobile() && (
                    <h1 id="session-timeout" className="fontSize_7 height160 largeBorder_black onlyBottomBorder lineHeight18">
                      {isLoggedIn
                        ? 'It looks like your session is about to expire.'
                        : `Just a heads up that your current session will expire in ${timeLeft} minutes because of inactivity.`}
                    </h1>
                  )}
                </Col>
                <Col xs={12} sm={12} lg={12}>
                  <div className={!isMobile() ? 'margin6 onlyTopMargin height96' : ''}>
                    {isLoggedIn ? (
                      <div>
                        <p>
                          You will be logged out of your session in&nbsp;
                          <span>{timeLeft}</span>.
                        </p>
                        <p>Do you want to continue with your session?</p>
                      </div>
                    ) : (
                      <p>{`You'll lose the items in your cart if your session expires.`}</p>
                    )}
                  </div>
                  {!isMobile() && (
                    <div className="btn-continue continueButtonWidth marginTop10 marginLeft20">
                      <Button
                        type="button"
                        className=""
                        primary
                        analyticstrack="Session_Continue"
                        onClick={(e) => sessionKeepAlive(e)}
                        size="large"
                        width="165px"
                      >
                        {isLoggedIn ? 'Continue' : <span className="block">Continue Session</span>}
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          )}
          {sessionTimedOut === true && (
            <div className="margin0 noPad" id={isLoggedIn ? 'sessionTimeOut' : 'sessionExpiry'}>
              <Row>
                <Col xs={10} sm={12} lg={12}>
                  {isMobile() && (
                    <Header size="titleMedium" className="pad24 onlyBottomPad">
                      {isLoggedIn ? 'Oops. Looks like your session has timed out.' : 'Oops. Looks like your session expired because of inactivity.'}
                    </Header>
                  )}
                  {!isMobile() && (
                    <h1 id="session-y" className="fontSize_7 height160 largeBorder_black onlyBottomBorder lineHeight18">
                      {isLoggedIn ? 'Oops. Looks like your session has timed out.' : 'Oops. Looks like your session expired because of inactivity.'}
                    </h1>
                  )}
                  <p className={!isMobile() ? 'margin6 onlyTopMargin height96' : ''}>
                    {isLoggedIn
                      ? "Your session isn't active anymore because of inactivity. Don't worry though, just log back in and start a new one."
                      : "You'll have to start your transaction over."}
                  </p>
                  {!isMobile() && (
                    <div className="btn-continue continueButtonWidth marginTop10 marginLeft20">
                      <Button
                        type="button"
                        className=""
                        primary
                        analyticstrack="Session_Continue"
                        onClick={(e) => onLogoff(e)}
                        size="large"
                        width="165px"
                      >
                        {isLoggedIn ? 'Log in' : <span className="block">Ok, thank you</span>}
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          )}
        </div>
      }
      modalFooter={
        isMobile() && (
          <div style={{ position: 'absolute', bottom: '0%', width: '100%', paddingRight: '16px', paddingBottom: '16px' }}>
            <Button
              type="button"
              className=""
              primary
              analyticstrack="Session_Continue"
              onClick={(e) => (sessionTimedOut === false ? sessionKeepAlive() : onLogoff(e))}
              width="100%"
            >
              {sessionTimedOut === false ? (
                isLoggedIn ? (
                  'Continue'
                ) : (
                  <span className="block">Continue Session</span>
                )
              ) : isLoggedIn ? (
                'Log in'
              ) : (
                <span className="block">Ok, thank you</span>
              )}
            </Button>
          </div>
        )
      }
    />
  </div>
);

TimeoutWarningModal.propTypes = {
  isOpen: PropTypes.any,
  isLoggedIn: PropTypes.any,
  sessionTimedOut: PropTypes.any,
  onLogoff: PropTypes.any,
  sessionKeepAlive: PropTypes.any,
  timeLeft: PropTypes.any,
};
